import { FormEvent } from "react";

interface IProps {
    label: string;
    name: string;
    value: string | number;
    onInputChange: (e: FormEvent<HTMLTextAreaElement>) => void;
    placeholder?: string;
    className?: string;
}

const FormTextArea = ({ className, name, value, onInputChange, placeholder, label }: IProps) => {
    return (
        <label className={"flex flex-col"}>
            <span className={"ml-0"}>{label}</span>
            <textarea
                name={name}
                value={value}
                placeholder={placeholder}
                rows={5}
                className={`appearance-none bg-neutral-500 rounded-3xl text-white border border-neutral-700 px-3 py-1 mt-2 ring-2 ring-offset-2 ring-transparent focus:ring-[#008DD2] ring-offset-neutral-700 outline-hidden transition-all overflow-hidden ${className}`}
                onInput={(e) => onInputChange(e)}
            />
        </label>
    );
};

export default FormTextArea;